// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-selector {
  position: absolute;
  display: inline-block;
  bottom: 0;
  left: 0;
  width: 128px;
  height: 80px;
  background-color: #444444;
  box-sizing: unset;
  line-height: 80px;
  text-align: center;
}
.help-selector.active {
  background-color: #b39841;
  z-index: 3;
  border: none;
}
.help-selector.active:hover span {
  color: #444444;
}
.help-selector span {
  color: #ffffff;
  font-family: Montserrat-Regular;
  font-size: 15px;
}
.help-selector span.video-icon {
  display: inline-block;
  height: 24px;
  width: 24px;
  background-image: url('to-be-televised.ebf1f4a4d03193f3.svg');
}
.help-selector p {
  color: #ffffff;
  font-family: Montserrat-Regular;
  font-size: 15px;
  display: inline-block;
}
.help-selector:hover {
  cursor: pointer;
}
.help-selector:hover span {
  color: #685925;
}
.help-container {
  overflow: hidden;
  height: 0px;
  max-height: 0px;
  position: absolute;
  bottom: 80px;
  left: 0;
  width: 256px;
  background-color: #444444;
  z-index: 3;
  transition: all 0.25s ease-in;
}
.help-container .help-content {
  display: none;
}
.help-container.active {
  display: block;
  height: auto;
  max-height: 320px;
  transition: max-height 0.1s ease-in;
  background-color: #b39841;
  height: 100%;
}
.help-container.active .help-content {
  display: block;
  padding: 5px 0 5px 5px;
  height: 100%;
}
.help-container.active .help-content .video-heading {
  display: block;
  font-family: WarnockPro-Semibold;
  margin-bottom: 5px;
  padding-top: 5px;
}
.help-container.active .help-content ul.video-list {
  list-style: none;
  margin-bottom: 5px;
  overflow-y: auto;
  height: 100%;
  width: 100%;
  max-height: 250px;
}
.help-container.active .help-content ul.video-list li {
  margin-left: -40px;
  margin-bottom: 5px;
  background-color: transparent;
  border-right: 6px solid #b39841;
}
.help-container.active .help-content ul.video-list li div.video {
  height: 80px;
  width: auto;
}
.help-container.active .help-content ul.video-list li div.video .thumb {
  position: relative;
  height: 100%;
  width: 100%;
  background-position: 0% 0%;
  background-repeat: no-repeat;
}
.help-container.active .help-content ul.video-list li div.video .thumb.default-thumbnail {
  background-image: url('video-thumb-example.dbd19d24698ed7fb.png') !important;
}
.help-container.active .help-content ul.video-list li div.video .thumb p.overlay-text {
  position: relative;
  height: 100%;
  width: 100%;
  display: none;
}
.help-container.active .help-content ul.video-list li:hover .video .thumb p.overlay-text {
  display: block;
  transition: 0.2s ease-in-out;
  background-color: #000000;
  opacity: 0.8;
  line-height: 25px;
  color: #ffffff;
  padding: 5px;
  text-align: center;
  vertical-align: central;
}
.help-container.active .help-content ul.video-list li.no-videos {
  background-color: #b39841;
  height: 245px;
  padding: 12px;
}
.help-container.active .help-content ul.video-list li.no-videos h4 {
  color: #ffffff;
  font-size: 16px;
}
.help-container.active .help-content ul.video-list:hover {
  cursor: pointer;
}
.help-container.active .help-content a.all {
  color: #444444;
  font-size: 12px;
}
.help-container.active .help-content a.all:hover {
  color: #ffffff !important;
}
.row .video-player {
  height: 400px;
  background-color: #333333;
}
.row .video-player span.video-icon {
  position: absolute;
  display: block;
  height: 200px;
  width: 200px;
  background-image: url('play.351b0ec764ae3239.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  top: 100px;
  left: 250px;
}
.row .more-videos {
  background-color: #333333;
  height: 400px;
  overflow-y: auto;
  padding: 10px;
  border-left: 1px solid #5e5e5e;
}
.row .more-videos .list-header {
  position: fixed;
  background-color: #333333;
  margin-top: -10px;
  padding-top: 10px;
  border-bottom: 1px solid #bbbbbb;
}
.row .more-videos .list-header input {
  border: none;
  font-family: 'Montserrat-Regular', sans-serif;
  color: #ffffff;
  outline: none;
  background-color: transparent;
  background-image: url('unselected-search.7cab5036cc625e30.svg');
  background-position: right 2px top 2px;
  background-repeat: no-repeat;
  background-size: 20px;
  transition: background-position 0.2s ease-in;
}
.row .more-videos .list-header input:focus {
  background-position: right -20px top 2px;
  transition: background-position 0.2s ease-in;
}
.row .more-videos .list-content {
  margin-top: 40px;
}
.row .more-videos .list-content ul.modal-video-list {
  list-style: none;
  margin-bottom: 5px;
}
.row .more-videos .list-content ul.modal-video-list li {
  margin-left: -40px;
  margin-bottom: 10px;
  background-color: transparent;
}
.row .more-videos .list-content ul.modal-video-list li .list-item {
  max-height: 40px;
  overflow: hidden;
}
.row .more-videos .list-content ul.modal-video-list li .list-item .thumb {
  display: inline-block;
  height: 40px;
  width: 40px;
  margin-right: 5px;
  background-image: url('video-thumb-example.dbd19d24698ed7fb.png');
  background-position: 10% 0%;
  background-repeat: no-repeat;
}
.row .more-videos .list-content ul.modal-video-list li .list-item .desc {
  display: inline-block;
  vertical-align: top;
}
.row .more-videos .list-content ul.modal-video-list li .list-item .desc p {
  max-width: 130px;
  font-size: 12px;
  color: #ffffff;
  word-wrap: break-word;
  text-overflow: ellipsis;
}
.row .more-videos .list-content ul.modal-video-list li:hover {
  cursor: pointer;
  background-color: #444444;
  opacity: 1.2;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/video-suggestions/video-suggestions.component.less"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AADJ;AAGI;EACI,yBAAA;EACA,UAAA;EACA,YAAA;AADR;AAGQ;EAEQ,cAAA;AAFhB;AAjBA;EAyBQ,cAAA;EACA,+BAAA;EACA,eAAA;AALR;AAOQ;EACI,qBAAA;EACA,YAAA;EACA,WAAA;EACA,6DAAA;AALZ;AA5BA;EAsCQ,cAAA;EACA,+BAAA;EACA,eAAA;EACA,qBAAA;AAPR;AAUI;EACI,eAAA;AARR;AAOI;EAIQ,cAAA;AARZ;AAaA;EACI,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,6BAAA;AAXJ;AACA;EAaQ,aAAA;AAXR;AAcI;EACI,cAAA;EACA,YAAA;EACA,iBAAA;EACA,mCAAA;EACA,yBAAA;EACA,YAAA;AAZR;AAMI;EASQ,cAAA;EACA,sBAAA;EACA,YAAA;AAZZ;AACI;EAcY,cAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AAZhB;AALI;EAqBY,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAbhB;AAbI;EA6BgB,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,+BAAA;AAbpB;AAnBI;EAmCoB,YAAA;EACA,WAAA;AAbxB;AAvBI;EAuCwB,kBAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,4BAAA;AAb5B;AAe4B;EACI,4EAAA;AAbhC;AAjCI;EAkD4B,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AAdhC;AAmBoB;EAIgB,cAAA;EACA,4BAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;AApBpC;AA0BoB;EACI,yBAAA;EACA,aAAA;EACA,aAAA;AAxBxB;AAqBoB;EAMQ,cAAA;EACA,eAAA;AAxB5B;AA6BgB;EACI,eAAA;AA3BpB;AA9DI;EA8FY,cAAA;EACA,eAAA;AA7BhB;AA+BgB;EACI,yBAAA;AA7BpB;AAoCA;EAEQ,aAAA;EACA,yBAAA;AAnCR;AAgCA;EAMY,kBAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;AAnCZ;AAoBA;EAoBQ,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;AArCR;AAaA;EA2BY,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gCAAA;AArCZ;AAMA;EAkCgB,YAAA;EACA,6CAAA;EACA,cAAA;EACA,aAAA;EACA,6BAAA;EACA,+DAAA;EACA,sCAAA;EACA,4BAAA;EACA,qBAAA;EACA,4CAAA;AArChB;AAuCgB;EACI,wCAAA;EACA,4CAAA;AArCpB;AAVA;EAqDY,gBAAA;AAxCZ;AAbA;EAwDgB,gBAAA;EACA,kBAAA;AAxChB;AAjBA;EA4DoB,kBAAA;EACA,mBAAA;EACA,6BAAA;AAxCpB;AAtBA;EAiEwB,gBAAA;EACA,gBAAA;AAxCxB;AA1BA;EAqE4B,qBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,iEAAA;EACA,2BAAA;EACA,4BAAA;AAxC5B;AAnCA;EA+E4B,qBAAA;EACA,mBAAA;AAzC5B;AAvCA;EAmFgC,gBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,uBAAA;AAzChC;AA8CoB;EACI,eAAA;EACA,yBAAA;EACA,YAAA;AA5CxB","sourcesContent":["@import (reference) '../../styles/variables.less';\n\n.help-selector {\n    position: absolute;\n    display: inline-block;\n    bottom: 0;\n    left: 0;\n    width: 128px;\n    height: 80px;\n    background-color: @secondary-90;\n    box-sizing: unset;\n    line-height: 80px;\n    text-align: center;\n\n    &.active {\n        background-color: @primary-90;\n        z-index: 3;\n        border: none;\n\n        &:hover {\n            span {\n                color: @secondary-90;\n            }\n        }\n    }\n\n    span {\n        color: @white;\n        font-family: Montserrat-Regular;\n        font-size: 15px;\n\n        &.video-icon {\n            display: inline-block;\n            height: 24px;\n            width: 24px;\n            background-image: url('../../styles/img/to-be-televised.svg');\n        }\n    }\n\n    p {\n        color: @white;\n        font-family: Montserrat-Regular;\n        font-size: 15px;\n        display: inline-block;\n    }\n\n    &:hover {\n        cursor: pointer;\n\n        span {\n            color: @primary-hover;\n        }\n    }\n}\n\n.help-container {\n    overflow: hidden;\n    height: 0px;\n    max-height: 0px;\n    position: absolute;\n    bottom: 80px;\n    left: 0;\n    width: 256px;\n    background-color: @secondary-90;\n    z-index: 3;\n    transition: all .25s ease-in;\n\n    .help-content {\n        display: none;\n    }\n\n    &.active {\n        display: block;\n        height: auto;\n        max-height: 320px;\n        transition: max-height .1s ease-in;\n        background-color: @primary-90;\n        height: 100%;\n\n        .help-content {\n            display: block;\n            padding: 5px 0 5px 5px;\n            height: 100%;\n\n            .video-heading {\n                display: block;\n                font-family: WarnockPro-Semibold;\n                margin-bottom: 5px;\n                padding-top: 5px;\n            }\n\n            ul.video-list {\n                list-style: none;\n                margin-bottom: 5px;\n                overflow-y: auto;\n                height: 100%;\n                width: 100%;\n                max-height: 250px;\n\n                li {\n                    margin-left: -40px;\n                    margin-bottom: 5px;\n                    background-color: transparent;\n                    border-right: 6px solid @primary-90;\n\n                    div.video {\n                        height: 80px;\n                        width: auto;\n\n                        .thumb {\n                            position: relative;\n                            height: 100%;\n                            width: 100%;\n                            background-position: 0% 0%;\n                            background-repeat: no-repeat;\n\n                            &.default-thumbnail {\n                                background-image: url('../../styles/img/video-thumb-example.png') !important;\n                            }\n\n                            p.overlay-text {\n                                position: relative;\n                                height: 100%;\n                                width: 100%;\n                                display: none;\n                            }\n                        }\n                    }\n\n                    &:hover {\n                        .video {\n                            .thumb {\n                                p.overlay-text {\n                                    display: block;\n                                    transition: .2s ease-in-out;\n                                    background-color: @black;\n                                    opacity: .80;\n                                    line-height: 25px;\n                                    color: @white;\n                                    padding: 5px;\n                                    text-align: center;\n                                    vertical-align: central;\n                                }\n                            }\n                        }\n                    }\n\n                    &.no-videos {\n                        background-color: @primary-90;\n                        height: 245px;\n                        padding: 12px;\n\n                        h4 {\n                            color: @white;\n                            font-size: 16px;\n                        }\n                    }\n                }\n\n                &:hover {\n                    cursor: pointer;\n                }\n            }\n\n            a.all {\n                color: @secondary-90;\n                font-size: 12px;\n\n                &:hover {\n                    color: @white !important;\n                }\n            }\n        }\n    }\n}\n\n.row {\n    .video-player {\n        height: 400px;\n        background-color: @secondary-base;\n\n        span.video-icon {\n            position: absolute;\n            display: block;\n            height: 200px;\n            width: 200px;\n            background-image: url('../../styles/img/play.svg');\n            background-repeat: no-repeat;\n            background-position: center;\n            background-size: cover;\n            top: 100px;\n            left: 250px;\n        }\n    }\n\n    .more-videos {\n        background-color: @secondary-base;\n        height: 400px;\n        overflow-y: auto;\n        padding: 10px;\n        border-left: 1px solid #5e5e5e;\n\n        .list-header {\n            position: fixed;\n            background-color: @secondary-base;\n            margin-top: -10px;\n            padding-top: 10px;\n            border-bottom: 1px solid @secondary-40;\n\n            input {\n                border: none;\n                font-family: 'Montserrat-Regular', sans-serif;\n                color: @white;\n                outline: none;\n                background-color: transparent;\n                background-image: url('../../styles/img/unselected-search.svg');\n                background-position: right 2px top 2px;\n                background-repeat: no-repeat;\n                background-size: 20px;\n                transition: background-position .2s ease-in;\n\n                &:focus {\n                    background-position: right -20px top 2px;\n                    transition: background-position .2s ease-in;\n                }\n            }\n        }\n\n        .list-content {\n            margin-top: 40px;\n\n            ul.modal-video-list {\n                list-style: none;\n                margin-bottom: 5px;\n\n                li {\n                    margin-left: -40px;\n                    margin-bottom: 10px;\n                    background-color: transparent;\n\n                    .list-item {\n                        max-height: 40px;\n                        overflow: hidden;\n\n                        .thumb {\n                            display: inline-block;\n                            height: 40px;\n                            width: 40px;\n                            margin-right: 5px;\n                            background-image: url('../../styles/img/video-thumb-example.png');\n                            background-position: 10% 0%;\n                            background-repeat: no-repeat;\n                        }\n\n                        .desc {\n                            display: inline-block;\n                            vertical-align: top;\n\n                            p {\n                                max-width: 130px;\n                                font-size: 12px;\n                                color: @white;\n                                word-wrap: break-word;\n                                text-overflow: ellipsis;\n                            }\n                        }\n                    }\n\n                    &:hover {\n                        cursor: pointer;\n                        background-color: @secondary-90;\n                        opacity: 1.2;\n                    }\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
